<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-05 18:57:39
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:24:38
 * @Description: file content
 -->
<template>
  <div class="container">
    <div class="item" @click="clickItem">
      <img :src="item.wxsmallpic" />
      <div class="right-layer">
        <span class="title">
          <span class="tag">{{item.tags ? item.tags + ' | ' : ''}}</span>
          {{item.title}}
        </span>
        <div class="center-layer">
          <!-- <div class="img" v-if="item.actheadimg">
            <img :src="item.actheadimg" />
          </div>
          <span class="t1" v-if="item.actheadimg">上传</span>-->
          <span class="time">{{item.time}}</span>
        </div>
        <div class="bottom-layer">
          <span class="icon i1">{{item.ll}}</span>
          <span class="icon i2">{{item.fx}}</span>
          <span class="icon i3">{{item.zx}}</span>
        </div>
        <span class="btn">
          <div class="img" v-if="item.actheadimg">
            <img :src="item.actheadimg" />
          </div>
          <span class="t1" v-if="item.actheadimg">上传</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  props: {
    item: {}
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    clickItem() {
      this.$emit("clickItem", this.item);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
.item {
  border-bottom: 1px solid #cecece;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.item img {
  width: 66px;
  height: 66px;
  border-radius: 4px;
  margin-right: 10px;
  display: block;
}
.item .right-layer {
  flex: 1;
  position: relative;
}
.item .right-layer .center-layer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 25px;
}
.item .right-layer .center-layer .img {
  width: 25px;
  height: 25px;
}
.item .right-layer .center-layer .img img {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  margin: 3px auto;
}
.item .right-layer .center-layer .t1 {
  font-size: 12px;
  color: #212121;
  margin-right: 10px;
}
.item .title {
  font-size: 14px;
  color: #212121;
  flex: 1;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}
.item .title .tag {
  color: #f25c5d;
  font-size: 14px;
  line-height: 20px;
}
.item .center-layer .time {
  font-size: 12px;
  color: #999999;
}
.item .right-layer .desc {
  /* max-height: 80rpx;
  line-height: 40rpx; */
  font-size: 12px;
  color: #f25c5d;
  /* display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden; 
  text-overflow: ellipsis;
  margin: 10rpx 0; */
}
.item .right-layer .bottom-layer {
  display: flex;
  justify-content: start;
  align-items: center;
}
.item .right-layer .bottom-layer .icon {
  width: 20%;
  font-size: 15px;
  color: #7d7b7c;
  padding-left: 20px;
}
.item .right-layer .bottom-layer .icon.i1 {
  background: url("https://assets.wxmp.ruthus.com/henduoke/intro/icon_1.png")
    no-repeat left center;
  background-size: 15px 10px;
}
.item .right-layer .bottom-layer .icon.i2 {
  background: url("https://assets.wxmp.ruthus.com/henduoke/intro/icon_2.png")
    no-repeat left center;
  background-size: 10px 10px;
}
.item .right-layer .bottom-layer .icon.i3 {
  background: url("https://assets.wxmp.ruthus.com/henduoke/intro/icon_3.png")
    no-repeat left center;
  background-size: 10px 10px;
}

.item .right-layer .btn {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 10px;
  text-align: center;
  bottom: -3px;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 25px;
}

.item .right-layer .btn .img {
  width: 25px;
  height: 25px;
}
.item .right-layer .btn .img img {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  border: 1px solid #f25c5d;
}

.item .right-layer .btn .t1 {
  font-size: 9px;
  color: #212121;
  margin-right: 10px;
}
</style>
